import { CHAPTERS, STATS } from '../data/content';
import { MaskedRevealOnView, FadeUp } from './motion/Reveal';
import { motion } from 'framer-motion';

const Manifesto = () => {
    return (
        <section id="work" data-testid="manifesto-section" className="bg-[#F4F5F6] text-[#0A0A0B] py-28 md:py-40 relative">
            <div className="mx-auto max-w-[1500px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-6 mb-20">
                    <div className="col-span-12 md:col-span-4">
                        <span className="overline text-[#FF3B00]">Manifesto</span>
                    </div>
                    <div className="col-span-12 md:col-span-8">
                        <MaskedRevealOnView
                            className="h-display text-[10vw] md:text-[6.2vw] leading-[0.9]"
                            lines={['Steel that does', 'what it promises.']}
                        />
                    </div>
                </div>

                <div className="space-y-24 md:space-y-32">
                    {CHAPTERS.map((c, i) => (
                        <div key={c.num} className="grid grid-cols-12 gap-6 items-start border-t border-[#0A0A0B]/15 pt-10">
                            <div className="col-span-12 md:col-span-4">
                                <FadeUp>
                                    <div className="overline text-[#0A0A0B]/50 mb-4">{c.overline}</div>
                                    <div className="h-display text-[22vw] md:text-[12vw] leading-none text-[#0A0A0B]/10 font-thin">
                                        {c.num}
                                    </div>
                                </FadeUp>
                            </div>
                            <div className="col-span-12 md:col-span-8">
                                <MaskedRevealOnView
                                    className="h-display text-3xl md:text-5xl lg:text-6xl mb-6"
                                    lines={c.title.split(/(?<=,)\s+/)}
                                />
                                <FadeUp delay={0.15}>
                                    <p className="text-[#0A0A0B]/75 text-base md:text-lg leading-relaxed max-w-2xl">
                                        {c.body}
                                    </p>
                                </FadeUp>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Stats block */}
                <div className="mt-32 border-t border-[#0A0A0B]/15 grid grid-cols-2 md:grid-cols-4">
                    {STATS.map((s, i) => (
                        <motion.div
                            key={s.k}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-60px' }}
                            transition={{ duration: 0.8, delay: i * 0.08 }}
                            className="py-10 md:py-14 px-4 md:px-8 border-r last:border-r-0 border-[#0A0A0B]/15"
                        >
                            <div className="h-display text-4xl md:text-6xl">{s.k}</div>
                            <div className="overline mt-3 text-[#0A0A0B]/60">{s.v}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Manifesto;
